module.exports = __webpack_public_path__ + "img/lrc-recommendation@2x.120e2697.png";